<template>
  <div id="app">
    <router-view v-loading.fullscreen.lock="loading"/>
    <!--<router-view />-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  computed:{
    ...mapGetters([
      'loading'
    ])
  }
}
</script>

<style>

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-width: 1100px;
}
a{
  text-decoration: none !important;
}

.editor-content ul li{
  list-style: disc;
}

.editor-content ol li{
  list-style: decimal;
}

.editor-content blockquote{
  margin: 0 0 0 40px;
  border: none;
  padding: 0;
}

.editor-content p{
  margin: 0;
}
.editor-content span{
  margin: 0;
}

.editor-content br{
  /* display: none; */
}

.law-button{
  transition: all 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  -webkit-transition: all 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  -o-transition: all 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  -moz-transition: all 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.law-button:hover{
  box-shadow:0px 4px 10px 0px rgba(215,233,255,1);
  -webkit-transform: translateY(-2px);
  -moz-transform: translateY(-2px);
  -o-transform: translateY(-2px);
  transform: translateY(-2px);
}

/* font-size */

.word-smaller {
  font-size: 12px;
}

.word-small {
  font-size: 13px;
}

.word-normal {
  font-size: 14px !important;
}

.word-middle {
  font-size: 16px;
}

.word-big {
  font-size: 18px;
}

.word-bigger {
  font-size: 20px;
}


/* icon-size */

.icon-smaller {
  width: 14px;
  display: inline-block;
  vertical-align: middle;
}

.icon-small {
  width: 16px;
  display: inline-block;
  vertical-align: middle;
}

.icon-middle {
  width: 18px;
  display: inline-block;
  vertical-align: middle;
}

.icon-big {
  width: 20px;
  display: inline-block;
  vertical-align: middle;
}

.icon-biggest {
  width: 40px;
  display: inline-block;
  vertical-align: middle;
}

.icon-smaller img,
.icon-small img,
.icon-middle img,
.icon-big img,
.icon-biggest img {
  width: 100%;
  display: block;
}

.operation-tip{
  width: 100%;
  margin: 150px 0;
  text-align: center;
}


.way-pic{
  margin-top: 26px;
}

.way{
  display: inline-block;
  width: 315px;
  border-radius:3px;
  box-sizing: border-box;
  border:1px solid rgba(169,196,223,1);
  margin: 0 4px;
}

.way-img{
  width: 150px;
  margin: 0 auto 20px auto;
}

.way-img img{
  width: 100%;
  display: block;
}

.no-data{
  margin: 150px auto;
  width: 280px;
}

.no-data img{
  width: 100%;
  display: block;
}
/* common */
.result .el-tabs__nav-wrap{
  background: @lineColor;
  border: 1px solid @lineColor;
  border-bottom: none;
  
}
.result .el-tabs__header{
  margin: 0 !important;
}

.result .el-icon-close{
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  line-height: 16px !important;
}

.result .el-tabs--card>.el-tabs__header .el-tabs__item.is-active.is-closable{
  padding: 0 20px !important;
}

.el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2), .el-tabs--bottom .el-tabs__item.is-top:nth-child(2), .el-tabs--top .el-tabs__item.is-bottom:nth-child(2), .el-tabs--top .el-tabs__item.is-top:nth-child(2){
  padding-left: 20px !important;
}

.result .el-tabs--card>.el-tabs__header .el-tabs__item.is-closable:hover{
  padding: 0 20px !important;
}

.result-tab-pane>.el-tabs__content{
  /* padding-top: 10px; */
  height: calc(100vh - 130px);
  overflow-y: auto;
}
.criminal-result .result-tab-pane>.el-tabs__content{
  padding-top: 0;
  height: calc(100vh - 120px);
}



.el-tabs__nav-next,.el-tabs__nav-prev{
  line-height: 35px !important;
}
.el-tabs__nav-prev{
  left: 4px !important;
}

.el-tabs__nav-next{
  right: 4px !important;
}


.law-detail-panel .el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2),
.law-detail-panel .el-tabs--bottom .el-tabs__item.is-top:nth-child(2),
.law-detail-panel .el-tabs--top .el-tabs__item.is-bottom:nth-child(2),
.law-detail-panel .el-tabs--top .el-tabs__item.is-top:nth-child(2){
  padding-left: 0;
}
.law-detail-panel .el-tabs--bottom .el-tabs__item.is-bottom:last-child,
.law-detail-panel .el-tabs--bottom .el-tabs__item.is-top:last-child,
.law-detail-panel .el-tabs--top .el-tabs__item.is-bottom:last-child,
.law-detail-panel .el-tabs--top .el-tabs__item.is-top:last-child{
  padding-right: 0;
}

.sticky-tab .el-tabs__nav-prev{
  top: 14px;
  padding: 0;
  left: 0px !important;
}

.sticky-tab .el-tabs__nav-next{
  top: 14px;
  padding: 0;
  right: 0px !important;
}

.sticky-tab .el-tabs__nav-wrap::after{
  display: none;
}

.el-menu {
  border-right: none !important;
}

.el-menu-item, .el-submenu__title{
  height: 34px !important;
  line-height: 34px !important;
}

.el-submenu .el-menu-item {
  padding: 0;
  height: 34px !important;
  line-height: 34px !important;
}

.el-menu-item {
  font-size: 13px;
  padding: 0 10px !important;
}

.el-submenu__icon-arrow {
  right: 10px;
}


.el-submenu__title{
  padding-left: 10px !important;
  padding-right: 18px !important;
  color: #222 !important;
  overflow: hidden;
  text-overflow:ellipsis;
}


.popper__arrow{
  /* left: 10px !important; */
}
.tool-tip{
  max-width: 300px;
  line-height: 21px !important;
  padding: 3px 5px !important;
}

 

.freeDialog .el-dialog__body{
    padding-top: 0;
}


.freeDialog .el-dialog__title{
    color: rgba(79, 94, 123, 1);
    font-size: 16px;
}


</style>

<style lang="less">
html,body{
  background: @backColor;
}
.operation-tip .tip-title{
  color:@mainColor;
  line-height: 25px;
  margin-bottom: 10px;
}

.el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow{
  color: @mainColor;
}
.el-tabs__item .el-icon-close:hover{
  background: @wordColor2;
}
.el-cascader-menu__item--extensible:after{
  right: 10px;
}

.el-cascader-menu__item{
  padding-left: 10px !important;
  padding-right: 28px !important;
}

.el-cascader-menu{
  height: auto !important;
  max-height: 27vh !important;
}

.editor-content{
  line-height: 28px;
}

.el-message{
  top: 80px;
}

.el-cascader-menu__wrap{
  height: 100% !important;
  overflow-x: hidden !important;
  overflow-y: scroll !important;
}
.el-cascader-node__postfix{
  top: 10px !important;
}
.el-button--primary{
  background-color: @mainColor !important;
  border-color:@mainColor !important;
}
.el-button--default{
  background: #E9F3FF;
  border: 1px solid @lineColor;
  color: @wordColor2;
}
.el-checkbox{
  color: @wordColor2 !important;
}
.el-step__head.is-process{
  color: #409EFF;
  border-color: #409EFF;
}
.el-step__title.is-process,
.el-step__title.is-finish{
  color: @wordColor1;
}

.is-finish{
  cursor: pointer;
}

.el-select .el-tag{
  background: @lineColor;
  color: @wordColor1;
}

.el-select .el-tag__close.el-icon-close{
  background-color:#879BBA;
}

.el-select .el-tag:hover .el-tag__close.el-icon-close{
  background-color: @mainColor;
}

.el-input-number--mini .el-input__inner{
  color:@wordColor2;
}

.el-input-number--mini .el-input-number__decrease [class*=el-icon], .el-input-number--mini .el-input-number__increase [class*=el-icon]{
  color: @wordColor2;
}

.el-input-number__decrease, .el-input-number__increase{
  background: #ECF1FA;
}

.el-input__icon{
  line-height: 35px !important;
}

.el-checkbox__inner{
    width: 16px !important;
    height: 16px !important;
}

.el-radio__inner{
  width: 16px !important;
  height: 16px !important;
}


.result-tab-pane>.el-tabs__header .el-tabs__item .el-icon-close{
  position: absolute !important;
  right: 15px !important;
  top: 12px !important;
  font-size: 16px !important;
}

.result .el-tabs__nav{
  height: 35px;
  line-height: 35px;
}
.el-tabs__item:hover{
  color: @mainColor!important;
}

.result .el-tabs--card>.el-tabs__header .el-tabs__item.is-active{
  background: #fff;
}

.result .el-tabs--card>.el-tabs__header .el-tabs__item.is-active::after{
  position: absolute;
  content: '';
  display: inline-block;
  width: 100%;
  height: 2px;
  background: @mainColor;
  left: 0;
  top: 0;
}


.result .el-tabs--card>.el-tabs__header .el-tabs__nav{
  border: none;
}

.result .el-tabs__item.is-active{
  color: @mainColor;
}


.result-body .el-tabs__item.is-active{
  color: #222;
  font-weight: bold;
  font-size: 16px;
}


.law-detail-panel .el-tabs__item.is-active{
  font-size: 16px !important;
  font-weight: bold !important;
}
.el-tabs__active-bar{
  height: 4px !important;
  background: @mainColor!important;
}
.law-detail-panel .el-tabs__nav{
  height: 40px !important;
  line-height: 40px !important;
}

.law-detail-panel .el-tabs__nav-wrap{
  border: none;
}

.el-tabs__item.is-disabled{
  color:#879BBA; 
}

.el-tabs__item.is-disabled:hover{
  color:#879BBA !important; 
}

.result .el-tabs__item{
  color: @wordColor1;
  min-width: 90px;
  max-width: 220px;
  position: relative;
  height: 35px;
  font-weight: normal !important;
}
</style>




// WEBPACK FOOTER //
// src/App.vue